// @flow

import * as GTM from "./tag-manager";

const setup = () => {
    // Handle language select events
    const languageSelect = document.querySelector(".gtranslate > select");
    if (languageSelect instanceof HTMLSelectElement) {
        languageSelect.addEventListener("change", (event: Event) => {
            if (event.target instanceof HTMLSelectElement) {
                const lang = event.target.value;
                GTM.setDatalayerVar("selected_language", lang);
                GTM.publishEvent("language_changed");
            }
        });
    }
};

window.addEventListener("load", setup);
